import { Component } from '@angular/core';

@Component({
  selector: 'app-float-button',
  standalone: true,
  imports: [],
  templateUrl: './float-button.component.html',
  styleUrl: './float-button.component.css'
})
export class FloatButtonComponent {

}
